import {baseAxios} from '../helper/axiosHelper';

export const numbergroupService = {
    getNumbergroupsByCompany,
    getNumbergroup,
    updateNumbergroup,
    insertNumbergroup,
    deleteNumbergroup
};

function getNumbergroupsByCompany(company_fk) {

    return baseAxios.get('company/numbergroups/',{params: {company_fk: company_fk}})
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}
function getNumbergroup(id) {

    return baseAxios.get('company/numbergroup/',{params: {id: id}} )
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}
function updateNumbergroup(data) {

    return baseAxios.put('company/numbergroup',data )
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}

function insertNumbergroup(data) {

    return baseAxios.post('company/numbergroup',data )
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}

function deleteNumbergroup(id) {

    return baseAxios.delete('company/numbergroup',{params: {id: id}}  )
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}
